import React, { ReactNode, useContext, useEffect, useState } from "react"

import { DragSourceDataContext } from "shared/context/drag-and-drop/DragSourceDataContext"
import { useTimeout } from "shared/lib/useTimeout"

import { DragAnimationContext } from "./AnimationContext"

interface AnimationContextProviderProps {
  children: ReactNode
}

export const AnimationContextProvider = React.memo(
  ({ children }: AnimationContextProviderProps) => {
    const { dragSource } = useContext(DragSourceDataContext)

    const [allowDragAnimations, setAllowDragAnimations] = useState(false)
    const timeout = useTimeout()

    useEffect(() => {
      if (dragSource?.id) {
        timeout.start(50, () => setAllowDragAnimations(true))
      } else {
        timeout.clear()
        setAllowDragAnimations(false)
      }
    }, [dragSource?.id])

    return (
      <DragAnimationContext.Provider
        value={allowDragAnimations && !!dragSource}
      >
        {children}
      </DragAnimationContext.Provider>
    )
  }
)
